module.exports = __webpack_public_path__ + "img/risk-dashboard.4858de79.png";